module.exports = __webpack_public_path__ + "static/testimonial2-b8c5a058b9ff07ebc81a6603918828de.png";